import React, { Component } from 'react';
import {connect} from 'react-redux';
import values from 'lodash/values';
import {
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  FormGroup,
  Popover,
  PopoverBody,
  FormText,
  Button
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import HiddenInput from '../../../shared/components/HiddenInput';

import TrashSVG from '../../../shared/assets/trash.svg';
import InformationSVG from '../../assets/information.svg';


import { generateGUID } from '../../../shared/utils';

const DCM_VENDOR_ID = '724c6c45-6c81-4425-8e1f-14d4bbe9601b';

function mapStateToProps(state) {
  return { tagVendors: state.entities.tagVendors};
}

class DCMTagInput extends Component {
  constructor(){
    super();

    this.state = {
      value:[],
      randomId:generateGUID(),
      tooltipOpen:false,
    };
  }

  // adjustVendor(vendor){
  //   if (vendor.vendor==="DV"){
  //     vendor.verify = true
  //   }
  //   console.log(vendor)
  //   return vendor
  // }

  componentWillMount(){
    const { defaultValue } = this.props;

    console.log(this.props)

    if(defaultValue) {
      defaultValue.forEach((tag) => {
        const vendor = this.props.tagVendors[tag.vendorId]
        if (vendor.verify) {
          tag.tag = tag.parameters
        }
        tag.vendor = vendor
      })
      this.setState({value: defaultValue});
    }
  }

  onVendorChanged(event, tag, tagIndex){
    const vendor = this.props.tagVendors[event.target.value]
    let newValue = this.state.value
    newValue[tagIndex].vendorId = vendor.id
    newValue[tagIndex].vendor = vendor
    this.setState({value: newValue});
  }

  handleAddTagClick(event){
    event.preventDefault();
    const vendor = Object.values(this.props.tagVendors)[0]
    const newValue = this.state.value.concat({
      tag:'',
      type:this.props.type,
      vendorId: vendor.id,
      vendor: vendor,
      clientId:generateGUID()
    });
    this.setState({value:newValue});

  }

  handleDeleteTagClick(event,tagIndex){
    event.preventDefault();

    let newValue = this.state.value;

    newValue.splice(tagIndex,1)

    this.setState({value:newValue});
  }

  render(){
    if (Object.values(this.props.tagVendors).length === 0) {
      return <div>No Tag Vendors Supported.</div>
    }
    return (
      <div>
        <Label>
          Vendor Tags
          <span>
            &nbsp;&nbsp;
            <img
              alt='Tooltip information'
              src={InformationSVG}
              id={`tooltip_${this.state.randomId}`}
              onMouseEnter={() => this.setState({tooltipOpen:true})}
              onMouseLeave={() => this.setState({tooltipOpen:false})}
            />
            <Popover
              className='TooltipPopover'
              isOpen={this.state.tooltipOpen}
              target={`tooltip_${this.state.randomId}`}
              placement='right'
            >
              <PopoverBody>
                Provide tags to track ad impressions, clicks, or viewability through your preferred measurement providers
              </PopoverBody>
            </Popover>
          </span>
        </Label>
        <div>
          {this.state.value.map((tag,tagIndex) => (
            <div key={`${tag.clientId}_${tag.id}`}>
              <Row>
                <Col xs='11'>
                  {tag.id && (
                    <HiddenInput
                      name={`${this.props.name}[${tagIndex}][id]`}
                      value={tag.id}
                    />
                  )}
                  <HiddenInput
                    name={`${this.props.name}[${tagIndex}][type]`}
                    value={tag.type}
                  />
                  <FormGroup>
                    <Input
                      type='select'
                      name={`${this.props.name}[${tagIndex}][vendorId]`}
                      value={tag.vendorId}
                      onChange={(event) => {this.onVendorChanged(event, tag, tagIndex)}}
                    >
                      {values(this.props.tagVendors).map((tagVendor) =>
                          <option key={tagVendor.id} value={tagVendor.id}>
                            {tagVendor.vendor}
                          </option>
                        )}
                    </Input>
                  </FormGroup>
                </Col>
                <Col xs='1'>
                  <img
                    src={TrashSVG}
                    className='TagTrashIcon'
                    onClick={(e) => this.handleDeleteTagClick(e,tagIndex)}
                    alt='Trash'
                  />
                </Col>
              </Row>
              <Row>
                <Col xs='12'>
                  <TextInput
                    name={`${this.props.name}[${tagIndex}][tag]`}
                    multiline
                    defaultValue={tag.tag}
                    placeholder={ (tag.vendor.verify) ? 'Parameters' : 'Full tag or URL'}
                    warning={this.props.warning.length > 0 ? this.props.warning[tagIndex] : ''}
                  />
                </Col>
              </Row>
            </div>
          ))}
          <Button
            size='sm'
            onClick={(e) => this.handleAddTagClick(e)}
          >
            Add Vendor Tag
          </Button>
        </div>
      </div>
    )
  }
}

DCMTagInput.defaultProps = {
  name:'tags',
  onSubmit:() => {},
  tags:[],
  warning:[]
};

export default connect(mapStateToProps)(DCMTagInput)



// WEBPACK FOOTER //
// ./src/shared/components/DCMTagInput/index.js